import { useLocation } from "react-router-dom";

export const Footer = () => {
  const { pathname } = useLocation();
  return (
    <footer
      className={`border-gray-200 px-2 sm:px-4 py-2.5  ${
        pathname === "/" || pathname === "/home"  ? "bg-lightgreen dark:bg-gray-800" : "bg-lightgreen dark:bg-gray-900  fixed bottom-0 w-full"
      }`}
    >
      <p className={`dark:text-white text-gray-900 text-center mb-0`}>
        Made by Vangel Angov &copy; 2022 
      </p>
    </footer>
  );
};
